/**
 * Constants for the Medical Billing Summaries feature
 */

export const MED_SUMMARY_FOLDER_NAME = 'Medical Billing Summaries'

// Legacy create/list deep-link path segments (redirected to the living summary so old URLs don't dead-end)
export enum MedSummaryTabs {
  CREATE_NEW = 'new',
  LIST = 'list',
}
